import { moduleFile } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import projectFacilityService from "@services/master-data/projectFacilityService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class ProjectFacilityStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.listData = []
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    const result = await projectFacilityService.createOrUpdate(body)
    this.detailData = result
    const { uniqueId } = result
    if (files && files.length && uniqueId) {
      files.forEach(async (file) => {
        if (file.originFileObj !== undefined) {
          const fileUpload = file.originFileObj
          await fileService.upload(
            moduleFile.projectFacility,
            uniqueId,
            fileUpload
          )
        }
      })
      this.isLoading = false
    }

    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.GetListProjectFacility()
  }

  @action
  async newProjectFacility() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await projectFacilityService.activate(id, isActive)
    appDataStore.GetListProjectFacility()
  }

  @action
  async get(id: number) {
    const result = await projectFacilityService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await projectFacilityService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await projectFacilityService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listData = result
  }
}

export default ProjectFacilityStore
